import AsyncStorage from '@react-native-async-storage/async-storage';

import { createStorage } from '@sg/mmkv-storage';

// ─────────────────────────────────────────────────────────────────────────────

export async function removeStoredCsrfToken() {
  AUTH_STORAGE.remove(CSRF_TOKEN_KEY);

  try {
    await AsyncStorage.removeItem(CSRF_TOKEN_KEY);
  } catch {}
}

// ─── Constants ───────────────────────────────────────────────────────────────

const AUTH_STORAGE = createStorage({ id: 'sg.auth' });
const CSRF_TOKEN_KEY = 'csrf-token';
